export default [
  {
    path: '/stage-levels',
    component: () => import('./views/Index'),
    name: 'stage_level',
    redirect: { name: 'stage_level-list' },
    children: [
      {
        path: '',
        name: 'stage_level-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: ':id',
        name: 'stage_level-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
